var _get = require("/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/get.js");

var _toConsumableArray = require("/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _defineProperty = require("/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/defineProperty.js");

var _regeneratorRuntime = require("/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/regenerator/index.js");

var _assertThisInitialized = require("/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/assertThisInitialized.js");

var _inherits = require("/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _wrapNativeSuper = require("/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");

var _classCallCheck = require("/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/createClass.js");

require("core-js/modules/es.promise.finally.js");

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(bn);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var It = Object.create;
var F = Object.defineProperty,
    Pt = Object.defineProperties,
    $t = Object.getOwnPropertyDescriptor,
    bt = Object.getOwnPropertyDescriptors,
    Mt = Object.getOwnPropertyNames,
    je = Object.getOwnPropertySymbols,
    Nt = Object.getPrototypeOf,
    Fe = Object.prototype.hasOwnProperty,
    wt = Object.prototype.propertyIsEnumerable;

var We = function We(t, e, n) {
  return e in t ? F(t, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: n
  }) : t[e] = n;
},
    Xe = function Xe(t, e) {
  for (var n in e || (e = {})) {
    Fe.call(e, n) && We(t, n, e[n]);
  }

  if (je) {
    var _iterator = _createForOfIteratorHelper(je(e)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var n = _step.value;
        wt.call(e, n) && We(t, n, e[n]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return t;
},
    Be = function Be(t, e) {
  return Pt(t, bt(e));
},
    He = function He(t) {
  return F(t, "__esModule", {
    value: !0
  });
};

var At = function At(t, e) {
  return function () {
    return e || t((e = {
      exports: {}
    }).exports, e), e.exports;
  };
},
    Ve = function Ve(t, e) {
  for (var n in e) {
    F(t, n, {
      get: e[n],
      enumerable: !0
    });
  }
},
    ze = function ze(t, e, n, r) {
  if (e && typeof e == "object" || typeof e == "function") {
    var _iterator2 = _createForOfIteratorHelper(Mt(e)),
        _step2;

    try {
      var _loop = function _loop() {
        var s = _step2.value;
        !Fe.call(t, s) && (n || s !== "default") && F(t, s, {
          get: function get() {
            return e[s];
          },
          enumerable: !(r = $t(e, s)) || r.enumerable
        });
      };

      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return t;
},
    Lt = function Lt(t, e) {
  return ze(He(F(t != null ? It(Nt(t)) : {}, "default", !e && t && t.__esModule ? {
    get: function get() {
      return t.default;
    },
    enumerable: !0
  } : {
    value: t,
    enumerable: !0
  })), t);
},
    St = function (t) {
  return function (e, n) {
    return t && t.get(e) || (n = ze(He({}), e, 1), t && t.set(e, n), n);
  };
}(typeof WeakMap != "undefined" ? new WeakMap() : 0);

var P = function P(t, e, n) {
  return new Promise(function (r, s) {
    var o = function o(c) {
      try {
        i(n.next(c));
      } catch (p) {
        s(p);
      }
    },
        a = function a(c) {
      try {
        i(n.throw(c));
      } catch (p) {
        s(p);
      }
    },
        i = function i(c) {
      return c.done ? r(c.value) : Promise.resolve(c.value).then(o, a);
    };

    i((n = n.apply(t, e)).next());
  });
};

var Et = At(function (dr, Ae) {
  "use strict";

  var wn = Object.prototype.hasOwnProperty,
      T = "~";

  function Y() {}

  Object.create && (Y.prototype = Object.create(null), new Y().__proto__ || (T = !1));

  function An(t, e, n) {
    this.fn = t, this.context = e, this.once = n || !1;
  }

  function mt(t, e, n, r, s) {
    if (typeof n != "function") throw new TypeError("The listener must be a function");
    var o = new An(n, r || t, s),
        a = T ? T + e : e;
    return t._events[a] ? t._events[a].fn ? t._events[a] = [t._events[a], o] : t._events[a].push(o) : (t._events[a] = o, t._eventsCount++), t;
  }

  function le(t, e) {
    --t._eventsCount === 0 ? t._events = new Y() : delete t._events[e];
  }

  function g() {
    this._events = new Y(), this._eventsCount = 0;
  }

  g.prototype.eventNames = function () {
    var e = [],
        n,
        r;
    if (this._eventsCount === 0) return e;

    for (r in n = this._events) {
      wn.call(n, r) && e.push(T ? r.slice(1) : r);
    }

    return Object.getOwnPropertySymbols ? e.concat(Object.getOwnPropertySymbols(n)) : e;
  };

  g.prototype.listeners = function (e) {
    var n = T ? T + e : e,
        r = this._events[n];
    if (!r) return [];
    if (r.fn) return [r.fn];

    for (var s = 0, o = r.length, a = new Array(o); s < o; s++) {
      a[s] = r[s].fn;
    }

    return a;
  };

  g.prototype.listenerCount = function (e) {
    var n = T ? T + e : e,
        r = this._events[n];
    return r ? r.fn ? 1 : r.length : 0;
  };

  g.prototype.emit = function (e, n, r, s, o, a) {
    var i = T ? T + e : e;
    if (!this._events[i]) return !1;
    var c = this._events[i],
        p = arguments.length,
        l,
        u;

    if (c.fn) {
      switch (c.once && this.removeListener(e, c.fn, void 0, !0), p) {
        case 1:
          return c.fn.call(c.context), !0;

        case 2:
          return c.fn.call(c.context, n), !0;

        case 3:
          return c.fn.call(c.context, n, r), !0;

        case 4:
          return c.fn.call(c.context, n, r, s), !0;

        case 5:
          return c.fn.call(c.context, n, r, s, o), !0;

        case 6:
          return c.fn.call(c.context, n, r, s, o, a), !0;
      }

      for (u = 1, l = new Array(p - 1); u < p; u++) {
        l[u - 1] = arguments[u];
      }

      c.fn.apply(c.context, l);
    } else {
      var x = c.length,
          L;

      for (u = 0; u < x; u++) {
        switch (c[u].once && this.removeListener(e, c[u].fn, void 0, !0), p) {
          case 1:
            c[u].fn.call(c[u].context);
            break;

          case 2:
            c[u].fn.call(c[u].context, n);
            break;

          case 3:
            c[u].fn.call(c[u].context, n, r);
            break;

          case 4:
            c[u].fn.call(c[u].context, n, r, s);
            break;

          default:
            if (!l) for (L = 1, l = new Array(p - 1); L < p; L++) {
              l[L - 1] = arguments[L];
            }
            c[u].fn.apply(c[u].context, l);
        }
      }
    }

    return !0;
  };

  g.prototype.on = function (e, n, r) {
    return mt(this, e, n, r, !1);
  };

  g.prototype.once = function (e, n, r) {
    return mt(this, e, n, r, !0);
  };

  g.prototype.removeListener = function (e, n, r, s) {
    var o = T ? T + e : e;
    if (!this._events[o]) return this;
    if (!n) return le(this, o), this;
    var a = this._events[o];
    if (a.fn) a.fn === n && (!s || a.once) && (!r || a.context === r) && le(this, o);else {
      for (var i = 0, c = [], p = a.length; i < p; i++) {
        (a[i].fn !== n || s && !a[i].once || r && a[i].context !== r) && c.push(a[i]);
      }

      c.length ? this._events[o] = c.length === 1 ? c[0] : c : le(this, o);
    }
    return this;
  };

  g.prototype.removeAllListeners = function (e) {
    var n;
    return e ? (n = T ? T + e : e, this._events[n] && le(this, n)) : (this._events = new Y(), this._eventsCount = 0), this;
  };

  g.prototype.off = g.prototype.removeListener;
  g.prototype.addListener = g.prototype.on;
  g.prefixed = T;
  g.EventEmitter = g;
  typeof Ae != "undefined" && (Ae.exports = g);
});
var zn = {};
Ve(zn, {
  Extension: function Extension() {
    return A;
  },
  MagicExtensionError: function MagicExtensionError() {
    return G;
  },
  MagicExtensionWarning: function MagicExtensionWarning() {
    return z;
  },
  MagicRPCError: function MagicRPCError() {
    return N;
  },
  MagicSDKError: function MagicSDKError() {
    return $;
  },
  MagicSDKWarning: function MagicSDKWarning() {
    return q;
  },
  SDKBase: function SDKBase() {
    return ye;
  },
  STORE_KEY_PRIVATE_KEY: function STORE_KEY_PRIVATE_KEY() {
    return Ee;
  },
  STORE_KEY_PUBLIC_JWK: function STORE_KEY_PUBLIC_JWK() {
    return ee;
  },
  TypedEmitter: function TypedEmitter() {
    return Le;
  },
  ViewController: function ViewController() {
    return Ke;
  },
  clearKeys: function clearKeys() {
    return De;
  },
  createDeprecationWarning: function createDeprecationWarning() {
    return $n;
  },
  createDuplicateIframeWarning: function createDuplicateIframeWarning() {
    return Pn;
  },
  createExtensionNotInitializedError: function createExtensionNotInitializedError() {
    return $e;
  },
  createIncompatibleExtensionsError: function createIncompatibleExtensionsError() {
    return be;
  },
  createInvalidArgumentError: function createInvalidArgumentError() {
    return Me;
  },
  createJwt: function createJwt() {
    return ke;
  },
  createMalformedResponseError: function createMalformedResponseError() {
    return Pe;
  },
  createMissingApiKeyError: function createMissingApiKeyError() {
    return Ie;
  },
  createModalNotReadyError: function createModalNotReadyError() {
    return In;
  },
  createPromiEvent: function createPromiEvent() {
    return Q;
  },
  createPromise: function createPromise() {
    return pe;
  },
  createReactNativeEndpointConfigurationWarning: function createReactNativeEndpointConfigurationWarning() {
    return we;
  },
  createSDK: function createSDK() {
    return lt;
  },
  createSynchronousWeb3MethodWarning: function createSynchronousWeb3MethodWarning() {
    return Ne;
  },
  createTypedEmitter: function createTypedEmitter() {
    return Z;
  },
  createURL: function createURL() {
    return fe;
  },
  decodeJSON: function decodeJSON() {
    return Te;
  },
  encodeJSON: function encodeJSON() {
    return H;
  },
  getPayloadId: function getPayloadId() {
    return ce;
  },
  isEmpty: function isEmpty() {
    return V;
  },
  isJsonRpcErrorCode: function isJsonRpcErrorCode() {
    return xe;
  },
  isJsonRpcRequestPayload: function isJsonRpcRequestPayload() {
    return vn;
  },
  isJsonRpcResponsePayload: function isJsonRpcResponsePayload() {
    return ve;
  },
  isMagicPayloadMethod: function isMagicPayloadMethod() {
    return xn;
  },
  isPromiEvent: function isPromiEvent() {
    return Se;
  },
  storage: function storage() {
    return K;
  },
  uuid: function uuid() {
    return Ce;
  }
});

function Ot(t) {
  var e = {
    exports: {}
  };
  return t(e, e.exports), e.exports;
}

var Ct = Number.MAX_SAFE_INTEGER || 9007199254740991;

var ge = {
  SEMVER_SPEC_VERSION: "2.0.0",
  MAX_LENGTH: 256,
  MAX_SAFE_INTEGER: Ct,
  MAX_SAFE_COMPONENT_LENGTH: 16
},
    _t = typeof process == "object" && process.env && process.env.NODE_DEBUG && /\bsemver\b/i.test(process.env.NODE_DEBUG) ? function () {
  var _console;

  for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
    t[_key] = arguments[_key];
  }

  return (_console = console).error.apply(_console, ["SEMVER"].concat(t));
} : function () {},
    d = _t,
    W = Ot(function (t, e) {
  var n = ge.MAX_SAFE_COMPONENT_LENGTH,
      r = (e = t.exports = {}).re = [],
      s = e.src = [],
      o = e.t = {},
      a = 0,
      i = function i(c, p, l) {
    var u = a++;
    d(u, p), o[c] = u, s[u] = p, r[u] = new RegExp(p, l ? "g" : void 0);
  };

  i("NUMERICIDENTIFIER", "0|[1-9]\\d*"), i("NUMERICIDENTIFIERLOOSE", "[0-9]+"), i("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"), i("MAINVERSION", "(".concat(s[o.NUMERICIDENTIFIER], ")\\.(").concat(s[o.NUMERICIDENTIFIER], ")\\.(").concat(s[o.NUMERICIDENTIFIER], ")")), i("MAINVERSIONLOOSE", "(".concat(s[o.NUMERICIDENTIFIERLOOSE], ")\\.(").concat(s[o.NUMERICIDENTIFIERLOOSE], ")\\.(").concat(s[o.NUMERICIDENTIFIERLOOSE], ")")), i("PRERELEASEIDENTIFIER", "(?:".concat(s[o.NUMERICIDENTIFIER], "|").concat(s[o.NONNUMERICIDENTIFIER], ")")), i("PRERELEASEIDENTIFIERLOOSE", "(?:".concat(s[o.NUMERICIDENTIFIERLOOSE], "|").concat(s[o.NONNUMERICIDENTIFIER], ")")), i("PRERELEASE", "(?:-(".concat(s[o.PRERELEASEIDENTIFIER], "(?:\\.").concat(s[o.PRERELEASEIDENTIFIER], ")*))")), i("PRERELEASELOOSE", "(?:-?(".concat(s[o.PRERELEASEIDENTIFIERLOOSE], "(?:\\.").concat(s[o.PRERELEASEIDENTIFIERLOOSE], ")*))")), i("BUILDIDENTIFIER", "[0-9A-Za-z-]+"), i("BUILD", "(?:\\+(".concat(s[o.BUILDIDENTIFIER], "(?:\\.").concat(s[o.BUILDIDENTIFIER], ")*))")), i("FULLPLAIN", "v?".concat(s[o.MAINVERSION]).concat(s[o.PRERELEASE], "?").concat(s[o.BUILD], "?")), i("FULL", "^".concat(s[o.FULLPLAIN], "$")), i("LOOSEPLAIN", "[v=\\s]*".concat(s[o.MAINVERSIONLOOSE]).concat(s[o.PRERELEASELOOSE], "?").concat(s[o.BUILD], "?")), i("LOOSE", "^".concat(s[o.LOOSEPLAIN], "$")), i("GTLT", "((?:<|>)?=?)"), i("XRANGEIDENTIFIERLOOSE", "".concat(s[o.NUMERICIDENTIFIERLOOSE], "|x|X|\\*")), i("XRANGEIDENTIFIER", "".concat(s[o.NUMERICIDENTIFIER], "|x|X|\\*")), i("XRANGEPLAIN", "[v=\\s]*(".concat(s[o.XRANGEIDENTIFIER], ")(?:\\.(").concat(s[o.XRANGEIDENTIFIER], ")(?:\\.(").concat(s[o.XRANGEIDENTIFIER], ")(?:").concat(s[o.PRERELEASE], ")?").concat(s[o.BUILD], "?)?)?")), i("XRANGEPLAINLOOSE", "[v=\\s]*(".concat(s[o.XRANGEIDENTIFIERLOOSE], ")(?:\\.(").concat(s[o.XRANGEIDENTIFIERLOOSE], ")(?:\\.(").concat(s[o.XRANGEIDENTIFIERLOOSE], ")(?:").concat(s[o.PRERELEASELOOSE], ")?").concat(s[o.BUILD], "?)?)?")), i("XRANGE", "^".concat(s[o.GTLT], "\\s*").concat(s[o.XRANGEPLAIN], "$")), i("XRANGELOOSE", "^".concat(s[o.GTLT], "\\s*").concat(s[o.XRANGEPLAINLOOSE], "$")), i("COERCE", "(^|[^\\d])(\\d{1,".concat(n, "})(?:\\.(\\d{1,").concat(n, "}))?(?:\\.(\\d{1,").concat(n, "}))?(?:$|[^\\d])")), i("COERCERTL", s[o.COERCE], !0), i("LONETILDE", "(?:~>?)"), i("TILDETRIM", "(\\s*)".concat(s[o.LONETILDE], "\\s+"), !0), e.tildeTrimReplace = "$1~", i("TILDE", "^".concat(s[o.LONETILDE]).concat(s[o.XRANGEPLAIN], "$")), i("TILDELOOSE", "^".concat(s[o.LONETILDE]).concat(s[o.XRANGEPLAINLOOSE], "$")), i("LONECARET", "(?:\\^)"), i("CARETTRIM", "(\\s*)".concat(s[o.LONECARET], "\\s+"), !0), e.caretTrimReplace = "$1^", i("CARET", "^".concat(s[o.LONECARET]).concat(s[o.XRANGEPLAIN], "$")), i("CARETLOOSE", "^".concat(s[o.LONECARET]).concat(s[o.XRANGEPLAINLOOSE], "$")), i("COMPARATORLOOSE", "^".concat(s[o.GTLT], "\\s*(").concat(s[o.LOOSEPLAIN], ")$|^$")), i("COMPARATOR", "^".concat(s[o.GTLT], "\\s*(").concat(s[o.FULLPLAIN], ")$|^$")), i("COMPARATORTRIM", "(\\s*)".concat(s[o.GTLT], "\\s*(").concat(s[o.LOOSEPLAIN], "|").concat(s[o.XRANGEPLAIN], ")"), !0), e.comparatorTrimReplace = "$1$2$3", i("HYPHENRANGE", "^\\s*(".concat(s[o.XRANGEPLAIN], ")\\s+-\\s+(").concat(s[o.XRANGEPLAIN], ")\\s*$")), i("HYPHENRANGELOOSE", "^\\s*(".concat(s[o.XRANGEPLAINLOOSE], ")\\s+-\\s+(").concat(s[o.XRANGEPLAINLOOSE], ")\\s*$")), i("STAR", "(<|>)?=?\\s*\\*"), i("GTE0", "^\\s*>=\\s*0.0.0\\s*$"), i("GTE0PRE", "^\\s*>=\\s*0.0.0-0\\s*$");
}),
    Ye = /^[0-9]+$/,
    Ze = function Ze(t, e) {
  var n = Ye.test(t),
      r = Ye.test(e);
  return n && r && (t = +t, e = +e), t === e ? 0 : n && !r ? -1 : r && !n ? 1 : t < e ? -1 : 1;
},
    Dt = function Dt(t, e) {
  return Ze(e, t);
},
    kt = {
  compareIdentifiers: Ze,
  rcompareIdentifiers: Dt
},
    Qe = ge.MAX_LENGTH,
    re = ge.MAX_SAFE_INTEGER,
    et = W.re,
    tt = W.t,
    X = kt.compareIdentifiers,
    E = /*#__PURE__*/function () {
  "use strict";

  function E(e, n) {
    _classCallCheck(this, E);

    if (n && typeof n == "object" || (n = {
      loose: !!n,
      includePrerelease: !1
    }), e instanceof E) {
      if (e.loose === !!n.loose && e.includePrerelease === !!n.includePrerelease) return e;
      e = e.version;
    } else if (typeof e != "string") throw new TypeError("Invalid Version: ".concat(e));

    if (e.length > Qe) throw new TypeError("version is longer than ".concat(Qe, " characters"));
    d("SemVer", e, n), this.options = n, this.loose = !!n.loose, this.includePrerelease = !!n.includePrerelease;
    var r = e.trim().match(n.loose ? et[tt.LOOSE] : et[tt.FULL]);
    if (!r) throw new TypeError("Invalid Version: ".concat(e));
    if (this.raw = e, this.major = +r[1], this.minor = +r[2], this.patch = +r[3], this.major > re || this.major < 0) throw new TypeError("Invalid major version");
    if (this.minor > re || this.minor < 0) throw new TypeError("Invalid minor version");
    if (this.patch > re || this.patch < 0) throw new TypeError("Invalid patch version");
    r[4] ? this.prerelease = r[4].split(".").map(function (s) {
      if (/^[0-9]+$/.test(s)) {
        var o = +s;
        if (o >= 0 && o < re) return o;
      }

      return s;
    }) : this.prerelease = [], this.build = r[5] ? r[5].split(".") : [], this.format();
  }

  _createClass(E, [{
    key: "format",
    value: function format() {
      return this.version = "".concat(this.major, ".").concat(this.minor, ".").concat(this.patch), this.prerelease.length && (this.version += "-".concat(this.prerelease.join("."))), this.version;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.version;
    }
  }, {
    key: "compare",
    value: function compare(e) {
      if (d("SemVer.compare", this.version, this.options, e), !(e instanceof E)) {
        if (typeof e == "string" && e === this.version) return 0;
        e = new E(e, this.options);
      }

      return e.version === this.version ? 0 : this.compareMain(e) || this.comparePre(e);
    }
  }, {
    key: "compareMain",
    value: function compareMain(e) {
      return e instanceof E || (e = new E(e, this.options)), X(this.major, e.major) || X(this.minor, e.minor) || X(this.patch, e.patch);
    }
  }, {
    key: "comparePre",
    value: function comparePre(e) {
      if (e instanceof E || (e = new E(e, this.options)), this.prerelease.length && !e.prerelease.length) return -1;
      if (!this.prerelease.length && e.prerelease.length) return 1;
      if (!this.prerelease.length && !e.prerelease.length) return 0;
      var n = 0;

      do {
        var r = this.prerelease[n],
            s = e.prerelease[n];
        if (d("prerelease compare", n, r, s), r === void 0 && s === void 0) return 0;
        if (s === void 0) return 1;
        if (r === void 0) return -1;
        if (r !== s) return X(r, s);
      } while (++n);
    }
  }, {
    key: "compareBuild",
    value: function compareBuild(e) {
      e instanceof E || (e = new E(e, this.options));
      var n = 0;

      do {
        var r = this.build[n],
            s = e.build[n];
        if (d("prerelease compare", n, r, s), r === void 0 && s === void 0) return 0;
        if (s === void 0) return 1;
        if (r === void 0) return -1;
        if (r !== s) return X(r, s);
      } while (++n);
    }
  }, {
    key: "inc",
    value: function inc(e, n) {
      switch (e) {
        case "premajor":
          this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", n);
          break;

        case "preminor":
          this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", n);
          break;

        case "prepatch":
          this.prerelease.length = 0, this.inc("patch", n), this.inc("pre", n);
          break;

        case "prerelease":
          this.prerelease.length === 0 && this.inc("patch", n), this.inc("pre", n);
          break;

        case "major":
          this.minor === 0 && this.patch === 0 && this.prerelease.length !== 0 || this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
          break;

        case "minor":
          this.patch === 0 && this.prerelease.length !== 0 || this.minor++, this.patch = 0, this.prerelease = [];
          break;

        case "patch":
          this.prerelease.length === 0 && this.patch++, this.prerelease = [];
          break;

        case "pre":
          if (this.prerelease.length === 0) this.prerelease = [0];else {
            var r = this.prerelease.length;

            for (; --r >= 0;) {
              typeof this.prerelease[r] == "number" && (this.prerelease[r]++, r = -2);
            }

            r === -1 && this.prerelease.push(0);
          }
          n && (this.prerelease[0] === n ? isNaN(this.prerelease[1]) && (this.prerelease = [n, 0]) : this.prerelease = [n, 0]);
          break;

        default:
          throw new Error("invalid increment argument: ".concat(e));
      }

      return this.format(), this.raw = this.version, this;
    }
  }]);

  return E;
}(),
    Jt = function Jt(t, e, n) {
  return new E(t, n).compare(new E(e, n));
},
    J = Jt,
    qt = function qt(t, e, n) {
  return J(t, e, n) === 0;
},
    Gt = qt,
    Ut = function Ut(t, e, n) {
  return J(t, e, n) !== 0;
},
    Kt = Ut,
    jt = function jt(t, e, n) {
  return J(t, e, n) > 0;
},
    Ft = jt,
    Wt = function Wt(t, e, n) {
  return J(t, e, n) >= 0;
},
    Xt = Wt,
    Bt = function Bt(t, e, n) {
  return J(t, e, n) < 0;
},
    Ht = Bt,
    Vt = function Vt(t, e, n) {
  return J(t, e, n) <= 0;
},
    zt = Vt,
    Yt = function Yt(t, e, n, r) {
  switch (e) {
    case "===":
      return typeof t == "object" && (t = t.version), typeof n == "object" && (n = n.version), t === n;

    case "!==":
      return typeof t == "object" && (t = t.version), typeof n == "object" && (n = n.version), t !== n;

    case "":
    case "=":
    case "==":
      return Gt(t, n, r);

    case "!=":
      return Kt(t, n, r);

    case ">":
      return Ft(t, n, r);

    case ">=":
      return Xt(t, n, r);

    case "<":
      return Ht(t, n, r);

    case "<=":
      return zt(t, n, r);

    default:
      throw new TypeError("Invalid operator: ".concat(e));
  }
},
    Re = Yt,
    B = Symbol("SemVer ANY"),
    C = /*#__PURE__*/function () {
  "use strict";

  function C(e, n) {
    _classCallCheck(this, C);

    if (n && typeof n == "object" || (n = {
      loose: !!n,
      includePrerelease: !1
    }), e instanceof C) {
      if (e.loose === !!n.loose) return e;
      e = e.value;
    }

    d("comparator", e, n), this.options = n, this.loose = !!n.loose, this.parse(e), this.semver === B ? this.value = "" : this.value = this.operator + this.semver.version, d("comp", this);
  }

  _createClass(C, [{
    key: "parse",
    value: function parse(e) {
      var n = this.options.loose ? nt[rt.COMPARATORLOOSE] : nt[rt.COMPARATOR],
          r = e.match(n);
      if (!r) throw new TypeError("Invalid comparator: ".concat(e));
      this.operator = r[1] !== void 0 ? r[1] : "", this.operator === "=" && (this.operator = ""), r[2] ? this.semver = new E(r[2], this.options.loose) : this.semver = B;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.value;
    }
  }, {
    key: "test",
    value: function test(e) {
      if (d("Comparator.test", e, this.options.loose), this.semver === B || e === B) return !0;
      if (typeof e == "string") try {
        e = new E(e, this.options);
      } catch (n) {
        return !1;
      }
      return Re(e, this.operator, this.semver, this.options);
    }
  }, {
    key: "intersects",
    value: function intersects(e, n) {
      if (!(e instanceof C)) throw new TypeError("a Comparator is required");
      if (n && typeof n == "object" || (n = {
        loose: !!n,
        includePrerelease: !1
      }), this.operator === "") return this.value === "" || new S(e.value, n).test(this.value);
      if (e.operator === "") return e.value === "" || new S(this.value, n).test(e.semver);
      var r = !(this.operator !== ">=" && this.operator !== ">" || e.operator !== ">=" && e.operator !== ">"),
          s = !(this.operator !== "<=" && this.operator !== "<" || e.operator !== "<=" && e.operator !== "<"),
          o = this.semver.version === e.semver.version,
          a = !(this.operator !== ">=" && this.operator !== "<=" || e.operator !== ">=" && e.operator !== "<="),
          i = Re(this.semver, "<", e.semver, n) && (this.operator === ">=" || this.operator === ">") && (e.operator === "<=" || e.operator === "<"),
          c = Re(this.semver, ">", e.semver, n) && (this.operator === "<=" || this.operator === "<") && (e.operator === ">=" || e.operator === ">");
      return r || s || o && a || i || c;
    }
  }], [{
    key: "ANY",
    get: function get() {
      return B;
    }
  }]);

  return C;
}(),
    nt = W.re,
    rt = W.t,
    S = /*#__PURE__*/function () {
  "use strict";

  function S(e, n) {
    var _this = this;

    _classCallCheck(this, S);

    if (n && typeof n == "object" || (n = {
      loose: !!n,
      includePrerelease: !1
    }), e instanceof S) return e.loose === !!n.loose && e.includePrerelease === !!n.includePrerelease ? e : new S(e.raw, n);
    if (e instanceof C) return this.raw = e.value, this.set = [[e]], this.format(), this;
    if (this.options = n, this.loose = !!n.loose, this.includePrerelease = !!n.includePrerelease, this.raw = e, this.set = e.split(/\s*\|\|\s*/).map(function (r) {
      return _this.parseRange(r.trim());
    }).filter(function (r) {
      return r.length;
    }), !this.set.length) throw new TypeError("Invalid SemVer Range: ".concat(e));
    this.format();
  }

  _createClass(S, [{
    key: "format",
    value: function format() {
      return this.range = this.set.map(function (e) {
        return e.join(" ").trim();
      }).join("||").trim(), this.range;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.range;
    }
  }, {
    key: "parseRange",
    value: function parseRange(e) {
      var _this2 = this;

      var n = this.options.loose;
      e = e.trim();
      var r = n ? y[f.HYPHENRANGELOOSE] : y[f.HYPHENRANGE];
      e = e.replace(r, un(this.options.includePrerelease)), d("hyphen replace", e), e = e.replace(y[f.COMPARATORTRIM], Zt), d("comparator trim", e, y[f.COMPARATORTRIM]), e = (e = (e = e.replace(y[f.TILDETRIM], Qt)).replace(y[f.CARETTRIM], en)).split(/\s+/).join(" ");
      var s = n ? y[f.COMPARATORLOOSE] : y[f.COMPARATOR];
      return e.split(" ").map(function (o) {
        return tn(o, _this2.options);
      }).join(" ").split(/\s+/).map(function (o) {
        return pn(o, _this2.options);
      }).filter(this.options.loose ? function (o) {
        return !!o.match(s);
      } : function () {
        return !0;
      }).map(function (o) {
        return new C(o, _this2.options);
      });
    }
  }, {
    key: "intersects",
    value: function intersects(e, n) {
      if (!(e instanceof S)) throw new TypeError("a Range is required");
      return this.set.some(function (r) {
        return st(r, n) && e.set.some(function (s) {
          return st(s, n) && r.every(function (o) {
            return s.every(function (a) {
              return o.intersects(a, n);
            });
          });
        });
      });
    }
  }, {
    key: "test",
    value: function test(e) {
      if (!e) return !1;
      if (typeof e == "string") try {
        e = new E(e, this.options);
      } catch (n) {
        return !1;
      }

      for (var n = 0; n < this.set.length; n++) {
        if (dn(this.set[n], e, this.options)) return !0;
      }

      return !1;
    }
  }]);

  return S;
}(),
    y = W.re,
    f = W.t,
    Zt = W.comparatorTrimReplace,
    Qt = W.tildeTrimReplace,
    en = W.caretTrimReplace,
    st = function st(t, e) {
  var n = !0,
      r = t.slice(),
      s = r.pop();

  for (; n && r.length;) {
    n = r.every(function (o) {
      return s.intersects(o, e);
    }), s = r.pop();
  }

  return n;
},
    tn = function tn(t, e) {
  return d("comp", t, e), t = sn(t, e), d("caret", t), t = nn(t, e), d("tildes", t), t = an(t, e), d("xrange", t), t = ln(t, e), d("stars", t), t;
},
    R = function R(t) {
  return !t || t.toLowerCase() === "x" || t === "*";
},
    nn = function nn(t, e) {
  return t.trim().split(/\s+/).map(function (n) {
    return rn(n, e);
  }).join(" ");
},
    rn = function rn(t, e) {
  var n = e.loose ? y[f.TILDELOOSE] : y[f.TILDE];
  return t.replace(n, function (r, s, o, a, i) {
    var c;
    return d("tilde", t, r, s, o, a, i), R(s) ? c = "" : R(o) ? c = ">=".concat(s, ".0.0 <").concat(+s + 1, ".0.0-0") : R(a) ? c = ">=".concat(s, ".").concat(o, ".0 <").concat(s, ".").concat(+o + 1, ".0-0") : i ? (d("replaceTilde pr", i), c = ">=".concat(s, ".").concat(o, ".").concat(a, "-").concat(i, " <").concat(s, ".").concat(+o + 1, ".0-0")) : c = ">=".concat(s, ".").concat(o, ".").concat(a, " <").concat(s, ".").concat(+o + 1, ".0-0"), d("tilde return", c), c;
  });
},
    sn = function sn(t, e) {
  return t.trim().split(/\s+/).map(function (n) {
    return on(n, e);
  }).join(" ");
},
    on = function on(t, e) {
  d("caret", t, e);
  var n = e.loose ? y[f.CARETLOOSE] : y[f.CARET],
      r = e.includePrerelease ? "-0" : "";
  return t.replace(n, function (s, o, a, i, c) {
    var p;
    return d("caret", t, s, o, a, i, c), R(o) ? p = "" : R(a) ? p = ">=".concat(o, ".0.0").concat(r, " <").concat(+o + 1, ".0.0-0") : R(i) ? p = o === "0" ? ">=".concat(o, ".").concat(a, ".0").concat(r, " <").concat(o, ".").concat(+a + 1, ".0-0") : ">=".concat(o, ".").concat(a, ".0").concat(r, " <").concat(+o + 1, ".0.0-0") : c ? (d("replaceCaret pr", c), p = o === "0" ? a === "0" ? ">=".concat(o, ".").concat(a, ".").concat(i, "-").concat(c, " <").concat(o, ".").concat(a, ".").concat(+i + 1, "-0") : ">=".concat(o, ".").concat(a, ".").concat(i, "-").concat(c, " <").concat(o, ".").concat(+a + 1, ".0-0") : ">=".concat(o, ".").concat(a, ".").concat(i, "-").concat(c, " <").concat(+o + 1, ".0.0-0")) : (d("no pr"), p = o === "0" ? a === "0" ? ">=".concat(o, ".").concat(a, ".").concat(i).concat(r, " <").concat(o, ".").concat(a, ".").concat(+i + 1, "-0") : ">=".concat(o, ".").concat(a, ".").concat(i).concat(r, " <").concat(o, ".").concat(+a + 1, ".0-0") : ">=".concat(o, ".").concat(a, ".").concat(i, " <").concat(+o + 1, ".0.0-0")), d("caret return", p), p;
  });
},
    an = function an(t, e) {
  return d("replaceXRanges", t, e), t.split(/\s+/).map(function (n) {
    return cn(n, e);
  }).join(" ");
},
    cn = function cn(t, e) {
  t = t.trim();
  var n = e.loose ? y[f.XRANGELOOSE] : y[f.XRANGE];
  return t.replace(n, function (r, s, o, a, i, c) {
    d("xRange", t, r, s, o, a, i, c);
    var p = R(o),
        l = p || R(a),
        u = l || R(i),
        x = u;
    return s === "=" && x && (s = ""), c = e.includePrerelease ? "-0" : "", p ? r = s === ">" || s === "<" ? "<0.0.0-0" : "*" : s && x ? (l && (a = 0), i = 0, s === ">" ? (s = ">=", l ? (o = +o + 1, a = 0, i = 0) : (a = +a + 1, i = 0)) : s === "<=" && (s = "<", l ? o = +o + 1 : a = +a + 1), s === "<" && (c = "-0"), r = "".concat(s + o, ".").concat(a, ".").concat(i).concat(c)) : l ? r = ">=".concat(o, ".0.0").concat(c, " <").concat(+o + 1, ".0.0-0") : u && (r = ">=".concat(o, ".").concat(a, ".0").concat(c, " <").concat(o, ".").concat(+a + 1, ".0-0")), d("xRange return", r), r;
  });
},
    ln = function ln(t, e) {
  return d("replaceStars", t, e), t.trim().replace(y[f.STAR], "");
},
    pn = function pn(t, e) {
  return d("replaceGTE0", t, e), t.trim().replace(y[e.includePrerelease ? f.GTE0PRE : f.GTE0], "");
},
    un = function un(t) {
  return function (e, n, r, s, o, a, i, c, p, l, u, x, L) {
    return "".concat(n = R(r) ? "" : R(s) ? ">=".concat(r, ".0.0").concat(t ? "-0" : "") : R(o) ? ">=".concat(r, ".").concat(s, ".0").concat(t ? "-0" : "") : a ? ">=".concat(n) : ">=".concat(n).concat(t ? "-0" : ""), " ").concat(c = R(p) ? "" : R(l) ? "<".concat(+p + 1, ".0.0-0") : R(u) ? "<".concat(p, ".").concat(+l + 1, ".0-0") : x ? "<=".concat(p, ".").concat(l, ".").concat(u, "-").concat(x) : t ? "<".concat(p, ".").concat(l, ".").concat(+u + 1, "-0") : "<=".concat(c)).trim();
  };
},
    dn = function dn(t, e, n) {
  for (var r = 0; r < t.length; r++) {
    if (!t[r].test(e)) return !1;
  }

  if (e.prerelease.length && !n.includePrerelease) {
    for (var _r = 0; _r < t.length; _r++) {
      if (d(t[_r].semver), t[_r].semver !== C.ANY && t[_r].semver.prerelease.length > 0) {
        var s = t[_r].semver;
        if (s.major === e.major && s.minor === e.minor && s.patch === e.patch) return !0;
      }
    }

    return !1;
  }

  return !0;
},
    ot = function ot(t, e, n) {
  try {
    e = new S(e, n);
  } catch (r) {
    return !1;
  }

  return e.test(t);
};

var mn = ge.MAX_LENGTH,
    it = W.re,
    at = W.t,
    En = function En(t, e) {
  if (e && typeof e == "object" || (e = {
    loose: !!e,
    includePrerelease: !1
  }), t instanceof E) return t;
  if (typeof t != "string" || t.length > mn || !(e.loose ? it[at.LOOSE] : it[at.FULL]).test(t)) return null;

  try {
    return new E(t, e);
  } catch (n) {
    return null;
  }
},
    hn = En,
    se = W.re,
    oe = W.t,
    ct = function ct(t, e) {
  if (t instanceof E) return t;
  if (typeof t == "number" && (t = String(t)), typeof t != "string") return null;
  var n = null;

  if ((e = e || {}).rtl) {
    var r;

    for (; (r = se[oe.COERCERTL].exec(t)) && (!n || n.index + n[0].length !== t.length);) {
      n && r.index + r[0].length === n.index + n[0].length || (n = r), se[oe.COERCERTL].lastIndex = r.index + r[1].length + r[2].length;
    }

    se[oe.COERCERTL].lastIndex = -1;
  } else n = t.match(se[oe.COERCE]);

  return n === null ? null : hn("".concat(n[2], ".").concat(n[3] || "0", ".").concat(n[4] || "0"), e);
};

function fn(t) {
  return String.fromCharCode(parseInt(t.slice(1), 16));
}

function yn(t) {
  return "%".concat("00".concat(t.charCodeAt(0).toString(16)).slice(-2));
}

function gn(t) {
  return btoa(encodeURIComponent(t).replace(/%[0-9A-F]{2}/g, fn));
}

function Rn(t) {
  return decodeURIComponent(Array.from(atob(t), yn).join(""));
}

function H(t) {
  return gn(JSON.stringify(t));
}

function Te(t) {
  return JSON.parse(Rn(t));
}

var I = require("@magic-sdk/types");

var ie = require("@magic-sdk/types");

function M(t) {
  return typeof t == "undefined";
}

function Tn(t) {
  return t === null;
}

function ae(t) {
  return Tn(t) || M(t);
}

function vn(t) {
  return ae(t) ? !1 : !M(t.jsonrpc) && !M(t.id) && !M(t.method) && !M(t.params);
}

function ve(t) {
  return ae(t) ? !1 : !M(t.jsonrpc) && !M(t.id) && (!M(t.result) || !M(t.error));
}

function xn(t) {
  return ae(t) ? !1 : typeof t == "string" && Object.values(ie.MagicPayloadMethod).includes(t);
}

function xe(t) {
  return ae(t) ? !1 : typeof t == "number" && Object.values(ie.RPCErrorCode).includes(t);
}

function V(t) {
  if (!t) return !0;

  for (var e in t) {
    if (Object.hasOwnProperty.call(t, e)) return !1;
  }

  return !0;
}

var m = {};

function lt(t, e) {
  return Object.assign(m, e), t;
}

var pt = {
  "magic-sdk": "magic-sdk",
  "@magic-sdk/react-native": "magic-sdk-rn"
};

var $ = /*#__PURE__*/function (_Error) {
  "use strict";

  _inherits($, _Error);

  var _super = _createSuper($);

  function $(e, n) {
    var _this3;

    _classCallCheck(this, $);

    _this3 = _super.call(this, "Magic SDK Error: [".concat(e, "] ").concat(n));
    _this3.code = e;
    _this3.rawMessage = n;
    _this3.__proto__ = Error;
    Object.setPrototypeOf(_assertThisInitialized(_this3), $.prototype);
    return _this3;
  }

  return _createClass($);
}( /*#__PURE__*/_wrapNativeSuper(Error)),
    N = /*#__PURE__*/function (_Error2) {
  "use strict";

  _inherits(N, _Error2);

  var _super2 = _createSuper(N);

  function N(e) {
    var _this4;

    _classCallCheck(this, N);

    _this4 = _super2.call(this);
    _this4.__proto__ = Error;
    var n = Number(e == null ? void 0 : e.code);
    _this4.rawMessage = (e == null ? void 0 : e.message) || "Internal error", _this4.code = xe(n) ? n : I.RPCErrorCode.InternalError, _this4.message = "Magic RPC Error: [".concat(_this4.code, "] ").concat(_this4.rawMessage), Object.setPrototypeOf(_assertThisInitialized(_this4), N.prototype);
    return _this4;
  }

  return _createClass(N);
}( /*#__PURE__*/_wrapNativeSuper(Error)),
    q = /*#__PURE__*/function () {
  "use strict";

  function q(e, n) {
    _classCallCheck(this, q);

    this.code = e;
    this.rawMessage = n;
    this.message = "Magic SDK Warning: [".concat(e, "] ").concat(n);
  }

  _createClass(q, [{
    key: "log",
    value: function log() {
      console.warn(this.message);
    }
  }]);

  return q;
}(),
    G = /*#__PURE__*/function (_Error3) {
  "use strict";

  _inherits(G, _Error3);

  var _super3 = _createSuper(G);

  function G(e, n, r, s) {
    var _this5;

    _classCallCheck(this, G);

    _this5 = _super3.call(this, "Magic Extension Error (".concat(e.name, "): [").concat(n, "] ").concat(r));
    _this5.code = n;
    _this5.rawMessage = r;
    _this5.data = s;
    _this5.__proto__ = Error;
    Object.setPrototypeOf(_assertThisInitialized(_this5), G.prototype);
    return _this5;
  }

  return _createClass(G);
}( /*#__PURE__*/_wrapNativeSuper(Error)),
    z = /*#__PURE__*/function () {
  "use strict";

  function z(e, n, r) {
    _classCallCheck(this, z);

    this.code = n;
    this.rawMessage = r;
    this.message = "Magic Extension Warning (".concat(e.name, "): [").concat(n, "] ").concat(r);
  }

  _createClass(z, [{
    key: "log",
    value: function log() {
      console.warn(this.message);
    }
  }]);

  return z;
}();

function Ie() {
  return new $(I.SDKErrorCode.MissingApiKey, "Please provide an API key that you acquired from the Magic developer dashboard.");
}

function In() {
  return new $(I.SDKErrorCode.ModalNotReady, "Modal is not ready.");
}

function Pe() {
  return new $(I.SDKErrorCode.MalformedResponse, "Response from the Magic iframe is malformed.");
}

function $e(t) {
  return new $(I.SDKErrorCode.ExtensionNotInitialized, "Extensions must be initialized with a Magic SDK instance before `Extension.".concat(t, "` can be accessed. Do not invoke `Extension.").concat(t, "` inside an extension constructor."));
}

function be(t) {
  var e = "Some extensions are incompatible with `".concat(m.sdkName, "@").concat(m.version, "`:");
  return t.filter(function (n) {
    return typeof n.compat != "undefined" && n.compat !== null;
  }).forEach(function (n) {
    var r = n.compat[m.sdkName];
    typeof r == "string" ? e += "\n  - Extension `".concat(n.name, "` supports version(s) `").concat(r, "`") : r || (e += "\n  - Extension `".concat(n.name, "` does not support ").concat(m.platform, " environments."));
  }), new $(I.SDKErrorCode.IncompatibleExtensions, e);
}

function Me(t) {
  var e = function e(n) {
    var r = n + 1,
        s = r % 10,
        o = r % 100;
    return s === 1 && o !== 11 ? "".concat(r, "st") : s === 2 && o !== 12 ? "".concat(r, "nd") : s === 3 && o !== 13 ? "".concat(r, "rd") : "".concat(r, "th");
  };

  return new $(I.SDKErrorCode.InvalidArgument, "Invalid ".concat(e(t.argument), " argument given to `").concat(t.procedure, "`.\n  Expected: `").concat(t.expected, "`\n  Received: `").concat(t.received, "`"));
}

function Pn() {
  return new q(I.SDKWarningCode.DuplicateIframe, "Duplicate iframes found.");
}

function Ne() {
  return new q(I.SDKWarningCode.SyncWeb3Method, "Non-async web3 methods are deprecated in web3 > 1.0 and are not supported by the Magic web3 provider. Please use an async method instead.");
}

function we() {
  return new q(I.SDKWarningCode.ReactNativeEndpointConfiguration, "CUSTOM DOMAINS ARE NOT SUPPORTED WHEN USING MAGIC SDK WITH REACT NATIVE! The `endpoint` parameter SHOULD NOT be provided. The Magic `<iframe>` is automatically wrapped by a WebView pointed at `".concat(m.defaultEndpoint, "`. Changing this default behavior will lead to unexpected results and potentially security-threatening bugs."));
}

function $n(t) {
  var e = t.method,
      n = t.removalVersions,
      r = t.useInstead,
      s = n[m.sdkName],
      o = r ? " Use `".concat(r, "` instead.") : "",
      a = "`".concat(e, "` will be removed from `").concat(m.sdkName, "` in version `").concat(s, "`.").concat(o);
  return new q(I.SDKWarningCode.DeprecationNotice, a);
}

var w = require("@magic-sdk/types");

var ue = require("@magic-sdk/types");

function bn() {
  var t;
  return _regeneratorRuntime.wrap(function bn$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          t = 0;

        case 1:
          if (!(t < Number.MAX_SAFE_INTEGER)) {
            _context.next = 6;
            break;
          }

          _context.next = 4;
          return ++t;

        case 4:
          _context.next = 7;
          break;

        case 6:
          t = 0;

        case 7:
          _context.next = 1;
          break;

        case 9:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

var Mn = bn();

function ce() {
  return Mn.next().value;
}

var ut = Symbol("Payload pre-processed by Magic SDK");

function dt(t) {
  return Object.defineProperty(t, ut, {
    value: !0,
    enumerable: !1
  }), t;
}

function Nn(t) {
  return !!t[ut];
}

function _(t) {
  var e, n, r;
  return Nn(t) || (t.jsonrpc = (e = t.jsonrpc) != null ? e : "2.0", t.id = ce(), t.method = (n = t.method) != null ? n : "noop", t.params = (r = t.params) != null ? r : [], dt(t)), t;
}

function h(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return dt({
    params: e,
    method: t,
    jsonrpc: "2.0",
    id: ce()
  });
}

var D = /*#__PURE__*/function () {
  "use strict";

  function D(e) {
    _classCallCheck(this, D);

    e instanceof D ? (this._jsonrpc = e.payload.jsonrpc, this._id = e.payload.id, this._result = e.payload.result, this._error = e.payload.error) : ve(e) ? (this._jsonrpc = e.jsonrpc, this._id = e.id, this._result = e.result, this._error = e.error) : (this._jsonrpc = e.jsonrpc, this._id = e.id, this._result = void 0, this._error = void 0);
  }

  _createClass(D, [{
    key: "applyError",
    value: function applyError(e) {
      return this._error = e, this;
    }
  }, {
    key: "applyResult",
    value: function applyResult(e) {
      return this._result = e, this;
    }
  }, {
    key: "hasError",
    get: function get() {
      return typeof this._error != "undefined" && this._error !== null;
    }
  }, {
    key: "hasResult",
    get: function get() {
      return typeof this._result != "undefined";
    }
  }, {
    key: "payload",
    get: function get() {
      return {
        jsonrpc: this._jsonrpc,
        id: this._id,
        result: this._result,
        error: this._error
      };
    }
  }]);

  return D;
}();

var ht = Lt(Et()),
    Le = /*#__PURE__*/function (_ht$default) {
  "use strict";

  _inherits(Le, _ht$default);

  var _super4 = _createSuper(Le);

  function Le() {
    _classCallCheck(this, Le);

    return _super4.apply(this, arguments);
  }

  return _createClass(Le);
}(ht.default);

function Z() {
  var t = new Le();
  return {
    emitter: t,
    createChainingEmitterMethod: function createChainingEmitterMethod(r, s) {
      return function () {
        for (var _len2 = arguments.length, o = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          o[_key2] = arguments[_key2];
        }

        return t[r].apply(t, o), s;
      };
    },
    createBoundEmitterMethod: function createBoundEmitterMethod(r) {
      return function () {
        for (var _len3 = arguments.length, s = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          s[_key3] = arguments[_key3];
        }

        return t[r].apply(t, s);
      };
    }
  };
}

var ft = Symbol("isPromiEvent");

function Se(t) {
  return !!t[ft];
}

function Q(t) {
  var e = pe(t),
      _Z = Z(),
      n = _Z.createBoundEmitterMethod,
      r = _Z.createChainingEmitterMethod,
      s = Symbol("Promise.then"),
      o = Symbol("Promise.catch"),
      a = Symbol("Promise.finally"),
      i = function i(l, u) {
    return function () {
      for (var _len4 = arguments.length, x = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        x[_key4] = arguments[_key4];
      }

      var L = u[l].apply(u, x);
      return c(L);
    };
  },
      c = function c(l) {
    var _Object$assign;

    return Object.assign(l, (_Object$assign = {}, _defineProperty(_Object$assign, ft, !0), _defineProperty(_Object$assign, s, l[s] || l.then), _defineProperty(_Object$assign, o, l[o] || l.catch), _defineProperty(_Object$assign, a, l[a] || l.finally), _defineProperty(_Object$assign, "then", i(s, l)), _defineProperty(_Object$assign, "catch", i(o, l)), _defineProperty(_Object$assign, "finally", i(a, l)), _defineProperty(_Object$assign, "on", r("on", l)), _defineProperty(_Object$assign, "once", r("once", l)), _defineProperty(_Object$assign, "addListener", r("addListener", l)), _defineProperty(_Object$assign, "off", r("off", l)), _defineProperty(_Object$assign, "removeListener", r("removeListener", l)), _defineProperty(_Object$assign, "removeAllListeners", r("removeAllListeners", l)), _defineProperty(_Object$assign, "emit", n("emit")), _defineProperty(_Object$assign, "eventNames", n("eventNames")), _defineProperty(_Object$assign, "listeners", n("listeners")), _defineProperty(_Object$assign, "listenerCount", n("listenerCount")), _Object$assign));
  },
      p = c(e.then(function (l) {
    return p.emit("done", l), p.emit("settled"), l;
  }, function (l) {
    throw p.emit("error", l), p.emit("settled"), l;
  }));

  return p;
}

function pe(t) {
  return new Promise(function (e, n) {
    var r = t(e, n);
    Promise.resolve(r).catch(n);
  });
}

var b = /*#__PURE__*/function () {
  "use strict";

  function b(e) {
    _classCallCheck(this, b);

    this.sdk = e;
  }

  _createClass(b, [{
    key: "overlay",
    get: function get() {
      return this.sdk.overlay;
    }
  }, {
    key: "request",
    value: function request(e) {
      var n = this.overlay.post(ue.MagicOutgoingWindowMessage.MAGIC_HANDLE_REQUEST, _(e)),
          r = Q(function (o, a) {
        n.then(function (i) {
          if (s(), i.hasError) a(new N(i.payload.error));else if (i.hasResult) o(i.payload.result);else throw Pe();
        }).catch(function (i) {
          s(), a(i);
        });
      }),
          s = this.overlay.on(ue.MagicIncomingWindowMessage.MAGIC_HANDLE_EVENT, function (o) {
        var i;
        var a = o.data.response;

        if (a.id === e.id && ((i = a.result) == null ? void 0 : i.event)) {
          var _a$result = a.result,
              c = _a$result.event,
              _a$result$params = _a$result.params,
              p = _a$result$params === void 0 ? [] : _a$result$params;
          r.emit.apply(r, [c].concat(_toConsumableArray(p)));
        }
      });
      return r;
    }
  }]);

  return b;
}();

var Oe = /*#__PURE__*/function (_b) {
  "use strict";

  _inherits(Oe, _b);

  var _super5 = _createSuper(Oe);

  function Oe() {
    _classCallCheck(this, Oe);

    return _super5.apply(this, arguments);
  }

  _createClass(Oe, [{
    key: "loginWithMagicLink",
    value: function loginWithMagicLink(e) {
      var n = e.email,
          _e$showUI = e.showUI,
          r = _e$showUI === void 0 ? !0 : _e$showUI,
          s = e.redirectURI,
          o = h(this.sdk.testMode ? w.MagicPayloadMethod.LoginWithMagicLinkTestMode : w.MagicPayloadMethod.LoginWithMagicLink, [{
        email: n,
        showUI: r,
        redirectURI: s
      }]);
      return this.request(o);
    }
  }, {
    key: "loginWithSMS",
    value: function loginWithSMS(e) {
      var n = e.phoneNumber,
          r = h(this.sdk.testMode ? w.MagicPayloadMethod.LoginWithSmsTestMode : w.MagicPayloadMethod.LoginWithSms, [{
        phoneNumber: n,
        showUI: !0
      }]);
      return this.request(r);
    }
  }, {
    key: "loginWithEmailOTP",
    value: function loginWithEmailOTP(e) {
      var n = e.email,
          r = h(this.sdk.testMode ? w.MagicPayloadMethod.LoginWithEmailOTPTestMode : w.MagicPayloadMethod.LoginWithEmailOTP, [{
        email: n,
        showUI: !0
      }]);
      return this.request(r);
    }
  }, {
    key: "loginWithCredential",
    value: function loginWithCredential(e) {
      var n = e != null ? e : "";

      if (!e && m.platform === "web") {
        n = window.location.search;
        var s = window.location.origin + window.location.pathname;
        window.history.replaceState(null, "", s);
      }

      var r = h(this.sdk.testMode ? w.MagicPayloadMethod.LoginWithCredentialTestMode : w.MagicPayloadMethod.LoginWithCredential, [n]);
      return this.request(r);
    }
  }]);

  return Oe;
}(b);

var v = require("@magic-sdk/types");

var K = {};
Ve(K, {
  clear: function clear() {
    return Ln;
  },
  getItem: function getItem() {
    return k;
  },
  iterate: function iterate() {
    return _n;
  },
  key: function key() {
    return On;
  },
  keys: function keys() {
    return Cn;
  },
  length: function length() {
    return Sn;
  },
  removeItem: function removeItem() {
    return me;
  },
  setItem: function setItem() {
    return U;
  }
});
var de;

function O(t) {
  var _this6 = this;

  return function () {
    for (var _len5 = arguments.length, e = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      e[_key5] = arguments[_key5];
    }

    return P(_this6, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _de;

      return _regeneratorRuntime.wrap(function _callee$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = de;

              if (_context2.t0) {
                _context2.next = 5;
                break;
              }

              _context2.next = 4;
              return m.configureStorage();

            case 4:
              de = _context2.sent;

            case 5:
              _context2.next = 7;
              return de.ready();

            case 7:
              return _context2.abrupt("return", (_de = de)[t].apply(_de, e));

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee);
    }));
  };
}

var k = O("getItem"),
    U = O("setItem"),
    me = O("removeItem"),
    Ln = O("clear"),
    Sn = O("length"),
    On = O("key"),
    Cn = O("keys"),
    _n = O("iterate");

function Ce() {
  var t = window.crypto.getRandomValues(new Uint8Array(16));
  t[6] = t[6] & 15 | 64, t[8] = t[8] & 191 | 128;
  var e = "";
  return e += t[0].toString(16), e += t[1].toString(16), e += t[2].toString(16), e += t[3].toString(16), e += "-", e += t[4].toString(16), e += t[5].toString(16), e += "-", e += t[6].toString(16), e += t[7].toString(16), e += "-", e += t[8].toString(16), e += t[9].toString(16), e += "-", e += t[10].toString(16), e += t[11].toString(16), e += t[12].toString(16), e += t[13].toString(16), e += t[14].toString(16), e += t[15].toString(16), e;
}

var Ee = "STORE_KEY_PRIVATE_KEY",
    ee = "STORE_KEY_PUBLIC_JWK",
    _e = "ECDSA",
    yt = "P-256",
    Dn = {
  name: _e,
  namedCurve: yt
},
    kn = {
  name: _e,
  namedCurve: yt
};

function De() {
  me(ee), me(Ee);
}

function ke() {
  return P(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var t, e, n, r, s, o, a, i, c;
    return _regeneratorRuntime.wrap(function _callee2$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return Jn();

          case 2:
            t = _context3.sent;

            if (t) {
              _context3.next = 6;
              break;
            }

            console.info("unable to create public key or webcrypto is unsupported");
            return _context3.abrupt("return");

          case 6:
            e = window.crypto.subtle;
            _context3.next = 9;
            return k(Ee);

          case 9:
            n = _context3.sent;

            if (!(!n || !e)) {
              _context3.next = 13;
              break;
            }

            console.info("unable to find private key or webcrypto unsupported");
            return _context3.abrupt("return");

          case 13:
            r = {
              iat: Math.floor(new Date().getTime() / 1e3),
              jti: Ce()
            };
            s = {
              typ: "dpop+jwt",
              alg: "ES256",
              jwk: t
            };
            o = {
              protected: gt(JSON.stringify(s)),
              claims: gt(JSON.stringify(r))
            };
            a = Un("".concat(o.protected, ".").concat(o.claims));
            i = {
              name: _e,
              hash: {
                name: "SHA-256"
              }
            };
            _context3.t0 = jn;
            _context3.t1 = Uint8Array;
            _context3.next = 22;
            return e.sign(i, n, a);

          case 22:
            _context3.t2 = _context3.sent;
            _context3.t3 = new _context3.t1(_context3.t2);
            c = (0, _context3.t0)(_context3.t3);
            return _context3.abrupt("return", "".concat(o.protected, ".").concat(o.claims, ".").concat(c));

          case 26:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee2);
  }));
}

function Jn() {
  return P(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (Gn()) {
              _context4.next = 3;
              break;
            }

            console.info("webcrypto is not supported");
            return _context4.abrupt("return");

          case 3:
            _context4.next = 5;
            return k(ee);

          case 5:
            _context4.t0 = _context4.sent;

            if (_context4.t0) {
              _context4.next = 9;
              break;
            }

            _context4.next = 9;
            return qn();

          case 9:
            return _context4.abrupt("return", k(ee));

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee3);
  }));
}

function qn() {
  return P(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var t, e, n, r, s;
    return _regeneratorRuntime.wrap(function _callee4$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            t = null;
            e = window.crypto.subtle;
            _context5.next = 4;
            return e.generateKey(Dn, !0, ["sign"]);

          case 4:
            n = _context5.sent;
            _context5.next = 7;
            return e.exportKey("jwk", n.privateKey);

          case 7:
            r = _context5.sent;
            _context5.next = 10;
            return e.exportKey("jwk", n.publicKey);

          case 10:
            t = _context5.sent;
            _context5.next = 13;
            return e.importKey("jwk", r, kn, !1, ["sign"]);

          case 13:
            s = _context5.sent;
            _context5.next = 16;
            return U(Ee, s);

          case 16:
            _context5.next = 18;
            return U(ee, t);

          case 18:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee4);
  }));
}

function Gn() {
  var t = typeof window != "undefined" && !!window.crypto,
      e = t && !!window.crypto.subtle;
  return t && e;
}

function gt(t) {
  return Rt(Kn(t));
}

function Un(t) {
  return new TextEncoder().encode(t);
}

function Rt(t) {
  return btoa(t).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+/g, "");
}

function Kn(t) {
  return encodeURIComponent(t).replace(/%([0-9A-F]{2})/g, function (n, r) {
    return String.fromCharCode(parseInt(r, 16));
  });
}

function jn(t) {
  var e = "";
  return t.forEach(function (n) {
    e += String.fromCharCode(n);
  }), Rt(e);
}

var Je = /*#__PURE__*/function (_b2) {
  "use strict";

  _inherits(Je, _b2);

  var _super6 = _createSuper(Je);

  function Je() {
    _classCallCheck(this, Je);

    return _super6.apply(this, arguments);
  }

  _createClass(Je, [{
    key: "getIdToken",
    value: function getIdToken(e) {
      var n = h(this.sdk.testMode ? v.MagicPayloadMethod.GetIdTokenTestMode : v.MagicPayloadMethod.GetIdToken, [e]);
      return this.request(n);
    }
  }, {
    key: "generateIdToken",
    value: function generateIdToken(e) {
      var n = h(this.sdk.testMode ? v.MagicPayloadMethod.GenerateIdTokenTestMode : v.MagicPayloadMethod.GenerateIdToken, [e]);
      return this.request(n);
    }
  }, {
    key: "getMetadata",
    value: function getMetadata() {
      var e = h(this.sdk.testMode ? v.MagicPayloadMethod.GetMetadataTestMode : v.MagicPayloadMethod.GetMetadata);
      return this.request(e);
    }
  }, {
    key: "updateEmail",
    value: function updateEmail(e) {
      var n = e.email,
          _e$showUI2 = e.showUI,
          r = _e$showUI2 === void 0 ? !0 : _e$showUI2,
          s = h(this.sdk.testMode ? v.MagicPayloadMethod.UpdateEmailTestMode : v.MagicPayloadMethod.UpdateEmail, [{
        email: n,
        showUI: r
      }]);
      return this.request(s);
    }
  }, {
    key: "isLoggedIn",
    value: function isLoggedIn() {
      var e = h(this.sdk.testMode ? v.MagicPayloadMethod.IsLoggedInTestMode : v.MagicPayloadMethod.IsLoggedIn);
      return this.request(e);
    }
  }, {
    key: "logout",
    value: function logout() {
      De();
      var e = h(this.sdk.testMode ? v.MagicPayloadMethod.LogoutTestMode : v.MagicPayloadMethod.Logout);
      return this.request(e);
    }
  }, {
    key: "showSettings",
    value: function showSettings() {
      var e = h(this.sdk.testMode ? v.MagicPayloadMethod.UserSettingsTestMode : v.MagicPayloadMethod.UserSettings);
      return this.request(e);
    }
  }]);

  return Je;
}(b);

var qe = require("@magic-sdk/types");

var _Z2 = Z(),
    he = _Z2.createBoundEmitterMethod,
    j = _Z2.createChainingEmitterMethod,
    Ge = /*#__PURE__*/function (_b3) {
  "use strict";

  _inherits(Ge, _b3);

  var _super7 = _createSuper(Ge);

  function Ge() {
    var _this7;

    _classCallCheck(this, Ge);

    _this7 = _super7.apply(this, arguments);
    _this7.isMagic = !0;
    _this7.on = j("on", _assertThisInitialized(_this7));
    _this7.once = j("once", _assertThisInitialized(_this7));
    _this7.addListener = j("addListener", _assertThisInitialized(_this7));
    _this7.off = j("off", _assertThisInitialized(_this7));
    _this7.removeListener = j("removeListener", _assertThisInitialized(_this7));
    _this7.removeAllListeners = j("removeAllListeners", _assertThisInitialized(_this7));
    _this7.emit = he("emit");
    _this7.eventNames = he("eventNames");
    _this7.listeners = he("listeners");
    _this7.listenerCount = he("listenerCount");
    return _this7;
  }

  _createClass(Ge, [{
    key: "sendAsync",
    value: function sendAsync(e, n) {
      var _this8 = this;

      if (!n) throw Me({
        procedure: "Magic.rpcProvider.sendAsync",
        argument: 1,
        expected: "function",
        received: n === null ? "null" : typeof n
      });
      if (Array.isArray(e)) this.overlay.post(qe.MagicOutgoingWindowMessage.MAGIC_HANDLE_REQUEST, e.map(function (r) {
        var s = _(r);

        return _this8.prefixPayloadMethodForTestMode(s), s;
      })).then(function (r) {
        n(null, r.map(function (s) {
          return Be(Xe({}, s.payload), {
            error: s.hasError ? new N(s.payload.error) : null
          });
        }));
      });else {
        var r = _(e);

        this.prefixPayloadMethodForTestMode(r), this.overlay.post(qe.MagicOutgoingWindowMessage.MAGIC_HANDLE_REQUEST, r).then(function (s) {
          n(s.hasError ? new N(s.payload.error) : null, s.payload);
        });
      }
    }
  }, {
    key: "send",
    value: function send(e, n) {
      if (typeof e == "string") {
        var s = h(e, Array.isArray(n) ? n : []);
        return this.request(s);
      }

      if (Array.isArray(e) || !!n) {
        this.sendAsync(e, n);
        return;
      }

      var r = Ne();
      return r.log(), new D(e).applyError({
        code: -32603,
        message: r.rawMessage
      }).payload;
    }
  }, {
    key: "enable",
    value: function enable() {
      var e = h("eth_accounts");
      return this.request(e);
    }
  }, {
    key: "request",
    value: function request(e) {
      return this.prefixPayloadMethodForTestMode(e), _get(_getPrototypeOf(Ge.prototype), "request", this).call(this, e);
    }
  }, {
    key: "prefixPayloadMethodForTestMode",
    value: function prefixPayloadMethodForTestMode(e) {
      var n = "testMode/eth/";
      this.sdk.testMode && (e.method = "".concat(n).concat(e.method));
    }
  }]);

  return Ge;
}(b);

function fe(t, e) {
  return e ? new URL(t, e) : new URL(t);
}

var Tt = ["request", "overlay", "sdk"];

function Fn(t) {
  var e = Object.getPrototypeOf(t),
      n = [e];

  for (; e !== b.prototype;) {
    e = Object.getPrototypeOf(e), n.push(e);
  }

  return n;
}

var Ue = /*#__PURE__*/function (_b4) {
  "use strict";

  _inherits(Ue, _b4);

  var _super8 = _createSuper(Ue);

  function Ue() {
    var _this9;

    _classCallCheck(this, Ue);

    _this9 = _super8.call(this, void 0);
    _this9.__sdk_access_field_descriptors__ = new Map();
    _this9.__is_initialized__ = !1;
    _this9.utils = {
      createPromiEvent: Q,
      isPromiEvent: Se,
      encodeJSON: H,
      decodeJSON: Te,
      createJsonRpcRequestPayload: h,
      standardizeJsonRpcRequestPayload: _,
      storage: K
    };
    var e = [_assertThisInitialized(_this9)].concat(_toConsumableArray(Fn(_assertThisInitialized(_this9))));
    Tt.forEach(function (n) {
      var r = e.map(function (i) {
        return Object.getOwnPropertyDescriptor(i, n);
      }),
          s = r.findIndex(function (i) {
        return !!i;
      }),
          o = s > 0,
          a = r[s];
      a && (_this9.__sdk_access_field_descriptors__.set(n, {
        descriptor: a,
        isPrototypeField: o
      }), Object.defineProperty(_assertThisInitialized(_this9), n, {
        configurable: !0,
        get: function get() {
          throw $e(n);
        }
      }));
    });
    return _this9;
  }

  _createClass(Ue, [{
    key: "init",
    value: function init(e) {
      var _this10 = this;

      this.__is_initialized__ || (Tt.forEach(function (n) {
        if (_this10.__sdk_access_field_descriptors__.has(n)) {
          var _this10$__sdk_access_ = _this10.__sdk_access_field_descriptors__.get(n),
              r = _this10$__sdk_access_.descriptor,
              s = _this10$__sdk_access_.isPrototypeField;

          s ? delete _this10[n] : Object.defineProperty(_this10, n, r);
        }
      }), this.sdk = e, this.__is_initialized__ = !0);
    }
  }, {
    key: "createDeprecationWarning",
    value: function createDeprecationWarning(e) {
      var n = e.method,
          r = e.removalVersion,
          s = e.useInstead,
          o = s ? " Use `".concat(s, "` instead.") : "",
          a = "`".concat(n, "` will be removed from this Extension in version `").concat(r, "`.").concat(o);
      return new z(this, "DEPRECATION_NOTICE", a);
    }
  }, {
    key: "createWarning",
    value: function createWarning(e, n) {
      return new z(this, e, n);
    }
  }, {
    key: "createError",
    value: function createError(e, n, r) {
      return new G(this, e, n, r);
    }
  }]);

  return Ue;
}(b),
    vt = /*#__PURE__*/function (_Ue) {
  "use strict";

  _inherits(vt, _Ue);

  var _super9 = _createSuper(vt);

  function vt() {
    _classCallCheck(this, vt);

    return _super9.apply(this, arguments);
  }

  return _createClass(vt);
}(Ue),
    A = /*#__PURE__*/function (_Ue2) {
  "use strict";

  _inherits(A, _Ue2);

  var _super10 = _createSuper(A);

  function A() {
    _classCallCheck(this, A);

    return _super10.apply(this, arguments);
  }

  return _createClass(A);
}(Ue);

A.Internal = vt, A.Anonymous = "anonymous extension";

function xt(t) {
  return t.compat && t.compat[m.sdkName] != null ? typeof t.compat[m.sdkName] == "string" ? ot(ct(m.version), t.compat[m.sdkName]) : !!t.compat[m.sdkName] : !0;
}

function Wn(t) {
  var _this11 = this;

  var s;
  var e = (s = t == null ? void 0 : t.extensions) != null ? s : [],
      n = {},
      r = [];
  if (Array.isArray(e) ? e.forEach(function (o) {
    xt(o) ? (o.init(_this11), (o.name || o.name !== A.Anonymous) && (_this11[o.name] = o), o instanceof A.Internal && (V(o.config) || (n[o.name] = o.config))) : r.push(o);
  }) : Object.keys(e).forEach(function (o) {
    if (xt(e[o])) {
      e[o].init(_this11);
      var a = e[o];
      _this11[o] = a, a instanceof A.Internal && (V(a.config) || (n[e[o].name] = a.config));
    } else r.push(e[o]);
  }), r.length) throw be(r);
  return n;
}

var te = /*#__PURE__*/function () {
  "use strict";

  function te(e, n) {
    _classCallCheck(this, te);

    this.apiKey = e;
    var a;
    if (!e) throw Ie();
    m.platform === "react-native" && (n == null ? void 0 : n.endpoint) && we().log();
    var r = m.defaultEndpoint,
        s = m.version;
    this.testMode = !!(n == null ? void 0 : n.testMode), this.endpoint = fe((a = n == null ? void 0 : n.endpoint) != null ? a : r).origin, this.auth = new Oe(this), this.user = new Je(this), this.rpcProvider = new Ge(this);
    var o = Wn.call(this, n);
    this.parameters = H({
      API_KEY: this.apiKey,
      DOMAIN_ORIGIN: window.location ? window.location.origin : "",
      ETH_NETWORK: n == null ? void 0 : n.network,
      host: fe(this.endpoint).host,
      sdk: pt[m.sdkName],
      version: s,
      ext: V(o) ? void 0 : o,
      locale: (n == null ? void 0 : n.locale) || "en_US"
    });
  }

  _createClass(te, [{
    key: "overlay",
    get: function get() {
      if (!te.__overlays__.has(this.parameters)) {
        var e = new m.ViewController(this.endpoint, this.parameters);
        e.init(), te.__overlays__.set(this.parameters, e);
      }

      return te.__overlays__.get(this.parameters);
    }
  }, {
    key: "preload",
    value: function preload() {
      return P(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.overlay.ready;

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }]);

  return te;
}(),
    ye = te;

ye.__overlays__ = new Map();

var ne = require("@magic-sdk/types");

function Xn(t, e) {
  return e && Array.isArray(t) ? t.find(function (n) {
    return n.id === e;
  }) : t;
}

function Bn(t, e) {
  var s;
  var n = (s = e.data.response) == null ? void 0 : s.id,
      r = Xn(t, n);

  if (n && r) {
    var o = new D(r).applyResult(e.data.response.result).applyError(e.data.response.error);
    return {
      id: n,
      response: o
    };
  }

  return {};
}

function Hn(t, e) {
  return P(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var n, r;
    return _regeneratorRuntime.wrap(function _callee6$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return k("rt");

          case 2:
            n = _context7.sent;

            if (!(m.platform === "web")) {
              _context7.next = 13;
              break;
            }

            _context7.prev = 4;
            _context7.next = 7;
            return ke();

          case 7:
            r = _context7.sent;
            _context7.next = 13;
            break;

          case 10:
            _context7.prev = 10;
            _context7.t0 = _context7["catch"](4);
            console.error("webcrypto error", _context7.t0);

          case 13:
            return _context7.abrupt("return", r ? n ? {
              msgType: t,
              payload: e,
              jwt: r,
              rt: n
            } : {
              msgType: t,
              payload: e,
              jwt: r
            } : {
              msgType: t,
              payload: e
            });

          case 14:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee6, null, [[4, 10]]);
  }));
}

function Vn(t) {
  return P(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    return _regeneratorRuntime.wrap(function _callee7$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.t0 = !t.data.rt;

            if (_context8.t0) {
              _context8.next = 4;
              break;
            }

            _context8.next = 4;
            return U("rt", t.data.rt);

          case 4:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee7);
  }));
}

var Ke = /*#__PURE__*/function () {
  "use strict";

  function Ke(e, n) {
    _classCallCheck(this, Ke);

    this.endpoint = e;
    this.parameters = n;
    this.messageHandlers = new Set();
    this.ready = this.waitForReady(), this.listen();
  }

  _createClass(Ke, [{
    key: "post",
    value: function post(e, n) {
      return P(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _this12 = this;

        return _regeneratorRuntime.wrap(function _callee9$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", pe(function (r) {
                  return P(_this12, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
                    var s, o, a, i, c;
                    return _regeneratorRuntime.wrap(function _callee8$(_context9) {
                      while (1) {
                        switch (_context9.prev = _context9.next) {
                          case 0:
                            _context9.next = 2;
                            return this.ready;

                          case 2:
                            s = [];
                            o = Array.isArray(n) ? n.map(function (p) {
                              return p.id;
                            }) : [];
                            _context9.next = 6;
                            return Hn("".concat(e, "-").concat(this.parameters), n);

                          case 6:
                            a = _context9.sent;
                            _context9.next = 9;
                            return this._post(a);

                          case 9:
                            i = function i(p) {
                              return function (l) {
                                var _Bn = Bn(n, l),
                                    u = _Bn.id,
                                    x = _Bn.response;

                                Vn(l), u && x && Array.isArray(n) && o.includes(u) ? (s.push(x), s.length === n.length && (p(), r(s))) : u && x && !Array.isArray(n) && u === n.id && (p(), r(x));
                              };
                            }, c = this.on(ne.MagicIncomingWindowMessage.MAGIC_HANDLE_RESPONSE, i(function () {
                              return c();
                            }));

                          case 10:
                          case "end":
                            return _context9.stop();
                        }
                      }
                    }, _callee8, this);
                  }));
                }));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee9);
      }));
    }
  }, {
    key: "on",
    value: function on(e, n) {
      var _this13 = this;

      var r = n.bind(window),
          s = function s(o) {
        o.data.msgType === "".concat(e, "-").concat(_this13.parameters) && r(o);
      };

      return this.messageHandlers.add(s), function () {
        return _this13.messageHandlers.delete(s);
      };
    }
  }, {
    key: "waitForReady",
    value: function waitForReady() {
      var _this14 = this;

      return new Promise(function (e) {
        _this14.on(ne.MagicIncomingWindowMessage.MAGIC_OVERLAY_READY, function () {
          return e();
        });
      });
    }
  }, {
    key: "listen",
    value: function listen() {
      var _this15 = this;

      this.on(ne.MagicIncomingWindowMessage.MAGIC_HIDE_OVERLAY, function () {
        _this15.hideOverlay();
      }), this.on(ne.MagicIncomingWindowMessage.MAGIC_SHOW_OVERLAY, function () {
        _this15.showOverlay();
      });
    }
  }]);

  return Ke;
}();

module.exports = St(zn);